import { INIT_NOTIF, SET_NOTIF } from './constants';

const initialState = {
    message: null,
    variant: null,
    duration: null,
    invoiceNotifications: {},
};

function notifReducer(state = initialState, action) {
    switch (action.type) {
        case 'SET_INVOICE_NOTIF': {
            const invoiceIds = Array.isArray(action.invoiceIds)
                ? action.invoiceIds
                : [action.invoiceId];

            const newNotifications = { ...state.invoiceNotifications };
            invoiceIds.forEach((id) => {
                newNotifications[id] = true;
            });
            return {
                ...state,
                invoiceNotifications: newNotifications,
            };
        }

        case 'UNSET_INVOICE_NOTIF':
            return {
                ...state,
                invoiceNotifications: Object.fromEntries(
                    Object.entries(state.invoiceNotifications).filter(
                        ([key]) => !action.invoiceIds.includes(Number(key))
                    )
                ),
            };

        case SET_NOTIF: {
            return {
                ...state,
                message: action?.notif?.message || null,
                variant: action?.notif?.variant || null,
                duration: action?.notif?.duration || null,
            };
        }
        case INIT_NOTIF: {
            return {
                ...state,
                message: null,
                variant: null,
                duration: null,
            };
        }
        default:
            return state;
    }
}

export default notifReducer;
